function ToastItem({ keyPrefix = "field", item, index, onRemove, type }) {
  if (item === "") {
    return null;
  }

  return (
    <div
      key={`${keyPrefix}` - `${index}`}
      className={`h-44 px-8   flex items-center justify-between font-16-21-400 my-4 ${
        type === "error" ? "bg-error error-text" : "bg-success success-text"
      }`}
    >
      <span className=" flex items-center gap-10">
        <img
          src={type === "error" ? "/circular-cross-icon.svg" : "/success.svg"}
          className="h-24 cursor-pointer"
          alt="close-icon"
        />
        {item}
      </span>

      <img
        src="/cross-dark.svg"
        className="h-24 cursor-pointer"
        alt="close-icon"
        onClick={() => onRemove(index)}
      />
    </div>
  );
}

export default ToastItem;
